<template>
  <b-modal
    ref="modal"
    id="new-order-modal"
    title="Modal Variants"
    hide-header
    hide-footer
    no-close-on-backdrop
    centered
    @hide="onHide"
    @show="onShow"
    static
  >
    <div class="right" v-if="!isDesktop">
      <div class="icon">
        <center>
          <font-awesome-icon @click="off" :icon="faTimes" />
        </center>
      </div>
    </div>
    <div class="header">
      <span>{{ (editOrder) ? $t('ORDER')+` #${ (orderDetail) ? orderDetail.id: null}` : $t('NEW_ORDER') }}</span>
    </div>
    <b-container>
      <b-row>
        <b-col md="12" lg="6">
          <text-input
            class="phone-icon"
            type="phoneNumber"
            icon-position="right"
            v-model="phone"
            @keyup="(e) => (editOrder) ? null: search(e)"
            @keydown.enter="(e) => (editOrder) ? null : searchHandle(e)"
            required
            ref="phoneInput"
            :label="$t('PHONE_CLI')"
            placeholder=" "
            borderbottom
            :disabled="editOrder ? disabled : false"
          >
            <template v-slot:icon>
              <font-awesome-icon v-if="editOrder && canWorkOn" class="icon right" :icon="faPhone" @click="() => startCall(phone)"/>
            </template>
          </text-input>
        </b-col>
        <b-col md="12" lg="6">
          <div class="floating-label"
               :class="{ disabled: disabled, active: !!source }">
            <select-input
              tabindex="-1"
              :items="sourceOptions"
              v-model="source"
              ref="sourceInput"
              borderless
              required
              :disabled="disabled || (source === ORDER_SOURCE.AFFILIATE)"
            />
            <span class="highlight"></span>
            <label>{{ $t("SOURCE")}}<span>*</span></label>
          </div>

          <text-input
            v-model="referralCode"
            :label="$t('REFERRAL_CODE')"
            borderbottom
            v-show="(source === ORDER_SOURCE.REFERRAL)"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" lg="6">
          <text-input
            v-model="firstName"
            ref="firstNameInput"
            :label="$t('FIRST_NAME')"
            placeholder=" "
            borderbottom
            :disabled="disabled"
          >
          </text-input>
        </b-col>
        <b-col md="12" lg="6">
          <text-input
            id="lastName"
            v-model="lastName"
            ref="lastNameInput"
            :label="$t('LAST_NAME')"
            placeholder=" "
            borderbottom
            :disabled="disabled"
          >
          </text-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" lg="6">
          <div class="floating-label"
               :class="{ active : !!assetType, disabled: disabled }">
            <select-input
              tabindex="-1"
              :items="assetOptions"
              v-model="assetType"
              ref="assetTypeInput"
              required
              borderless
              :disabled="disabled"
            />
            <span class="highlight"></span>
            <label>{{ $t("ASSET_TYPE")}}<span>*</span></label>
          </div>
        </b-col>
        <b-col md="12" lg="6">
          <text-input
            type="positiveNumber"
            id="expectedAmount"
            v-model="expectedAmount"
            ref="expectedAmountInput"
            :label="$t('EXPECTED_AMOUNT')"
            placeholder=" "
            borderbottom
            :hint="expectedAmountHint"
            :disabled="disabled"
          >
          </text-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" lg="6">
          <div class="floating-label textarea" :class="{ disabled: disabled } ">
            <textarea
              class="floating-textarea"
              v-model="assetDescription"
              ref="assetDescriptionInput"
              :label="$t('ASSET_DESCRIPTION')"
              placeholder=" "
              required
              :disabled="disabled"
            >
            </textarea>
            <span class="highlight"></span>
            <label>{{ $t('ASSET_DESCRIPTION') }}<span>*</span></label>
            <small class="red" v-if="!!validateMessageTexarea">{{ validateMessageTexarea }}</small>
          </div>
        </b-col>
        <b-col md="12" lg="6">
          <text-input
            type="positiveNumber"
            id="validatorAmount"
            v-model="validatorAmount"
            ref="validatorAmountInput"
            :label="$t('VALIDATOR_AMOUNT')"
            placeholder=" "
            borderbottom
            :hint="validatorAmountHint"
            :disabled="disabled"
          >
          </text-input>
        </b-col>
      </b-row>
      <b-row v-if="editOrder">
        <b-col md="12" lg="6">
          <div class="floating-label" :class="{ active : !!stepOrder }">
            <select-input
              tabindex="-1"
              :items="stepOptions"
              v-model="stepOrder"
              ref="stepOrderInput"
              borderless
              required
            />
            <span class="highlight"></span>
            <label>{{ $t("STAGE")}}<span>*</span></label>
          </div>
        </b-col>
        <b-col md="12" lg="6">
          <div class="floating-label"
               :class="{ active : !!stageOrder}">
            <select-input
              tabindex="-1"
              :items="stageOptions"
              v-model="stageOrder"
              ref="stageOrderInput"
              borderless
              required
            />
            <span class="highlight"></span>
            <label>{{ $t("STEP")}}<span>*</span></label>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!editOrder">
        <b-col md="12" lg="6">
          <div class="floating-label"
               :class="{ disabled: disabled, active: !!validators }">
            <select-input
              tabindex="-1"
              :items="validatorsOptions"
              v-model="validators"
              ref="validatorsInput"
              borderless
              :disabled="disabled"
            />
            <span class="highlight"></span>
            <label>{{ $t("VALIDATOR")}}</label>
          </div>
        </b-col>
        <b-col md="12" lg="6">
        </b-col>
      </b-row>
      <b-row v-if="editOrder">
        <b-col md="12" lg="6">
          <div class="floating-label" :class="{ active: !!validators}">
            <select-input
              tabindex="-1"
              :items="validatorsOptions"
              v-model="validators"
              ref="validatorsInput"
              borderless
            />
            <span class="highlight"></span>
            <label>{{ $t("VALIDATOR")}}</label>
          </div>
        </b-col>
        <b-col md="12" lg="6">
          <text-input
            type="datetime-local"
            v-model="appointment"
            ref="appointmentInput"
            :label="$t('APPOINTMENT_SCHEDULE')"
            borderbottom
            :disabled="appointmentDisabled"
            required
          >
          </text-input>
        </b-col>
      </b-row>
      <b-row v-if="editOrder">
        <b-col md="12" lg="4">
          <text-input
            v-model="staffUsername"
            ref="staffUsernameInput"
            :label="$t('PERSON_IN_CHARGE')"
            placeholder=" "
            borderbottom
            :disabled="true"
          >
          </text-input>
        </b-col>
        <b-col md="12" lg="4">
          <text-input
            v-model="supportUsername"
            ref="supportUsernameInput"
            :label="$t('HELPER')"
            placeholder=" "
            borderbottom
            :disabled="true"
          >
          </text-input>
        </b-col>
        <b-col md="12" lg="4">
          <text-input
            v-model="branchName"
            ref="branchNameInput"
            :label="$t('BRANCH')"
            placeholder=" "
            borderbottom
            :disabled="true"
          >
          </text-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" lg="12">
          <div class="notes-wrapper" ref="notesBox" v-if="orderNotes.length > 0 && editOrder">
            <div class="notes">
              <p :key="noteOrder.id" v-for="noteOrder in orderNotes">
                <span>{{ moment(noteOrder.createdAt, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]').format('DD/MM/YYYY HH:mm') }}</span>
                <span> - </span>
                <span>{{ noteOrder.createdBy.firstName }} {{ noteOrder.createdBy.lastName }}</span>
                <span>: </span>
                <span>{{ noteOrder.content }}</span>
              </p>
            </div>
          </div>
          <div class="notes-input">
            <text-input
              :label="$t('NOTES')"
              placeholder=" "
              borderbottom
              icon-position="right"
              v-model="orderNote"
              @keydown.enter="(e) => addNotes(e)"
              ref="noteOrderInput"
              :disabled="disabled"
            >
              <template v-slot:icon>
                <font-awesome-icon class="icon right" :icon="faPaperPlane" @click="addNotes"/>
              </template>
            </text-input>
          </div>
        </b-col>
      </b-row>
      <div v-show="stepOrder === ORDER_STEP.CONTRACT" class="at-home-support">
        <b-row>
          <b-col md="12" lg="12">
            <div class="checkbox-wrapper">
              <input type="checkbox" :checked="isAtHomeSupport" @change="toggleIsAtHomeSupport()" />
              <label class="label">{{ $t('IS_AT_HOME_SUPPORT') }}</label>
            </div>
          </b-col>
        </b-row>

        <b-row v-show="isAtHomeSupport">
          <b-col md="12" lg="6">
            <div class="floating-label" :class="{ active: !!validators}">
              <select-input
                tabindex="-1"
                :items="validatorsOptions"
                v-model="validators"
                ref="atHomeValidatorInput"
                borderless
                required
              />
              <span class="highlight"></span>
              <label>{{ $t('VALIDATOR')}}<span>*</span></label>
            </div>
          </b-col>

          <b-col md="12" lg="6">
            <div class="floating-label" :class="{ active: !!supportingValidator}">
              <select-input
                tabindex="-1"
                :items="validatorsOptions"
                v-model="supportingValidator"
                ref="atHomeSupportingValidatorInput"
                borderless
                required
              />
              <span class="highlight"></span>
              <label>{{ $t('VALIDATOR')}} 2</label>
            </div>
          </b-col>

          <b-col md="12" lg="6">
            <select-input
              :label="$t('PROVINCE_MUNICIPALITY')"
              v-model="city"
              :items="cities"
              required
              borderbottom
              ref="cityInput"
            />
          </b-col>

          <b-col md="12" lg="6">
            <select-input
              :label="$t('DISTRICT_PROVINCIAL_CITY')"
              v-model="district"
              :items="districts"
              borderbottom
              required
              ref="districtInput"
            />
          </b-col>

          <b-col md="12" lg="6">
            <text-input
              :label="$t('ADDRESS')"
              borderbottom
              v-model="address"
              ref="addressInput"
              required
            />
          </b-col>

          <b-col md="12" lg="6">
            <text-input
              type="datetime-local"
              v-model="appointment"
              ref="atHomeAppointmentInput"
              :label="$t('APPOINTMENT_SCHEDULE')"
              borderbottom
              required
            >
            </text-input>
          </b-col>
        </b-row>
      </div>
      <b-row align-h="between">
        <b-col lg="2" md="12">
          <small><span>*</span>{{ $t("REQUIRED_FIELD") }}</small>
        </b-col>
        <b-col class=btn-footer lg="10" md="12">
          <div v-if="isDesktop">
            <primary-button @click="()=> off()" grey rounded-corner :text="$t('CANCEL')" />
            <primary-button v-if="!editOrder" @click="temptSaveData" blue rounded-corner :text="$t('TEMPORARY_SAVE')" />
            <primary-button v-if="!contractBtnDisabled || !editOrder" @click="() => (editOrder) ? contractHandle(): createOrderHandle(changeRouter=true)" independence rounded-corner :text="$t('CONTRACTS')" />
            <primary-button
              class="red-btn"
              red
              rounded-corner
              :text="$t('OK')"
              @click="() => (editOrder) ? updateOrderHandle() : createOrderHandle(changeRouter=false)"
              v-if="canWorkOn"
            />
          </div>
          <div v-else class="btn-footer">
            <primary-button @click="()=> off()" grey :text="$t('CANCEL')" />
            <primary-button v-if="!editOrder" @click="temptSaveData" blue :text="$t('TEMPORARY_SAVE')" />
            <primary-button v-if="!contractBtnDisabled || !editOrder" @click="() => (editOrder) ? contractHandle(): createOrderHandle(changeRouter=true)" independence :text="$t('CONTRACTS')" />
            <primary-button
              class="red-btn"
              red
              :text="$t('OK')"
              @click="() => (editOrder) ? updateOrderHandle() : createOrderHandle(changeRouter=false)"
              v-if="canWorkOn"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { ref, watch, computed, getCurrentInstance } from '@vue/composition-api';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import $ from 'jquery';

import { ORDER_STEP, ORDER_STAGE, ORDER_STATUS, ORDER_SOURCE, PATHS, CALL_REFS } from '@/consts';
import { changeDigitToViText, applyParams } from '@/helpers';

import { faPaperPlane, faPhone, faTimes } from '@fortawesome/free-solid-svg-icons';

import PrimaryButton from '@/components/PrimaryButton';
import TextInput from '@/components/TextInput';
import SelectInput from '@/components/SelectInput';
import OrderManagementService from '../OrderManagementService';


const { useGetters: useModalGetters, useActions: useModalActions } = createNamespacedHelpers('modal');
const { useState: useAppState } = createNamespacedHelpers('app');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useActions, useState: useOrderSate } = createNamespacedHelpers('orderList');
const { useActions: usePhoneActions } = createNamespacedHelpers('phone');
const { useState: useUserState } = createNamespacedHelpers('user');

export default {
  name: 'ConfirmModal',
  components: {
    PrimaryButton,
    TextInput,
    SelectInput,
    FontAwesomeIcon
  },

  props: {
    editOrder: Boolean,
    orderDetail: Object,
    getStages: Function,
    getKeyStepTranslations: Function,
    getKeyStageTranslations: Function
  },

  setup(props, { root: { $router } }) {
    const vm = getCurrentInstance();

    const modal = ref(null);

    const { locations } = useAppState(['locations']);

    const phone = ref('');
    const phoneInput = ref(null);
    const lastName = ref('');
    const lastNameInput = ref(null);
    const firstName = ref('');
    const firstNameInput = ref(null);
    const assetDescription = ref('');
    const assetDescriptionInput = ref(null);
    const source = ref(null);
    const sourceInput = ref(null);
    const expectedAmount = ref('');
    const expectedAmountInput = ref(null);
    const validatorAmount = ref('');
    const validatorAmountInput = ref(null);
    const assetType = ref(null);
    const assetTypeInput = ref(null);
    const orderNote = ref('');
    const orderNoteInput = ref(null);
    const orderNotes = ref([]);
    const stageOrder = ref(null);
    const stageOrderInput = ref(null);
    const stepOrder = ref(null);
    const stepOrderInput = ref(null);
    const staffUsername = ref('');
    const staffUsernameInput = ref(null);
    const supportUsername = ref('');
    const supportUsernameInput = ref(null);
    const branchName = ref('');
    const branchNameInput = ref(null);
    const appointment = ref(null);
    const appointmentInput = ref(null);
    const workingAgent = ref(null);
    const validators = ref(null);
    const validatorsInput = ref(null);
    const referralCode = ref(null);

    const supportingValidator = ref(null);
    const isAtHomeSupport = ref(false);
    const atHomeValidatorInput = ref(null);
    const atHomeSupportingValidatorInput = ref(null);
    const atHomeAppointmentInput = ref(null);

    const city = ref(1);
    const district = ref(null);
    const address = ref('');

    const cityInput = ref(null);
    const districtInput = ref(null);
    const addressInput = ref(null);

    const cities = computed(() => locations.value.filter((item) => (
      item.type.level === 1
    )).map((item) => ({
      text: item.name,
      value: item.id
    })));

    const districts = computed(() => locations.value.filter((item) => (
      (item.type.level === 2)
      && (item.parent === city.value)
    )).map((item) => ({
      text: item.name,
      value: item.id
    })));

    const newClient = ref(null);
    const disabled = ref(true);
    const searchTime = ref(null);
    const clientDisabled = ref(true);
    const appointmentDisabled = ref(true);
    const notesBox = ref(null);
    const contractBtnDisabled = ref(true);

    // validate textarea and style input textarea
    const validateMessageTexarea = ref('');
    const inputHeight = ref(null);

    const { getStages, getKeyStepTranslations, getKeyStageTranslations } = props;
    const orderDetail = computed(() => (props.orderDetail));

    const { info, error } = useFlashActions(['info', 'error']);
    const { isEditOrderModalActive: isOpen } = useModalGetters(['isEditOrderModalActive']);
    const { toggleEditOrderModal: toggleEditOrder } = useModalActions(['toggleEditOrderModal']);
    const { assetTypes, validators: validatorState, isDesktop } = useAppState(['assetTypes', 'validators', 'isDesktop']);
    const { client } = useOrderSate(['client', 'items']);
    const { startOutboundCall, setRef } = usePhoneActions(['startOutboundCall', 'setRef']);
    const { profile } = useUserState(['profile']);

    const canWorkOn = computed(() => (!orderDetail.value?.workingAgent || (orderDetail.value.workingAgent.username === profile.value.username)));

    const {
      getOrderList,
      getMyOrderList,
      getClientByPhoneNumber,
      resetClientState } = useActions([
      'getOrderList',
      'getMyOrderList',
      'getClientByPhoneNumber',
      'resetClientState'
    ]);

    const expectedAmountHint = computed(() => (changeDigitToViText(expectedAmount.value)));
    const validatorAmountHint = computed(() => (changeDigitToViText(validatorAmount.value)));

    const assetOptions = computed(() => assetTypes.value.map((asset) => ({
      text: asset.description,
      value: asset.description
    })));

    // change list source when new Client or old Client
    const orderSources = computed(() => Object.values(ORDER_SOURCE).reduce((sourceList, sourceItem) => {
      if (newClient.value && sourceItem !== ORDER_SOURCE.OLD_CUSTOMER) {
        sourceList.push(sourceItem);
      } else if (!newClient.value && sourceItem === ORDER_SOURCE.OLD_CUSTOMER) {
        sourceList.push(sourceItem);
      }
      return sourceList;
    }, []));

    // render source list
    const sourceOptions = computed(() => orderSources.value.map((item) => ({
      text: item,
      value: item,
      unenabled: (item === ORDER_SOURCE.AFFILIATE)
    })));

    const orderSteps = computed(() => Object.values(ORDER_STEP).reduce((stepList, stepItem) => {
      if (stepItem !== ORDER_STEP.UNCLAIMED
          && stepItem !== ORDER_STEP.COLD_LEAD
          && stepItem !== ORDER_STEP.WARM_LEAD) {
        stepList.push(stepItem);
      }
      return stepList;
    }, []));
    const stepOptions = computed(() => orderSteps.value.map((item) => ({
      text: vm.$i18n.t(getKeyStepTranslations(item)),
      value: (item)
    })));

    const stageOptions = computed(() => getStages(stepOrder.value).map((item) => ({
      text: vm.$i18n.t(getKeyStageTranslations(item)),
      value: (item)
    })));

    const validatorsOptions = computed(() => validatorState.value.map((item) => ({
      text: item.username,
      value: item.id
    })));

    // validate textarea
    const validateTextarea = () => {
      if (!assetDescriptionInput.value.validity.valid) {
        validateMessageTexarea.value = vm.$i18n.t('REQUIRED_FIELD');
      } else {
        validateMessageTexarea.value = '';
      }
    };

    const clearValidateTextarea = () => {
      validateMessageTexarea.value = '';
    };

    // auto size textarea
    const resizeTextArea = () => {
      const currentH = $(assetDescriptionInput.value).height();
      $(assetDescriptionInput.value).height('auto');
      const h = assetDescriptionInput.value.scrollHeight;
      $(assetDescriptionInput.value).height(currentH);
      $(assetDescriptionInput.value).height(h);
      inputHeight.value = `${h}px`;
    };

    const reset = () => {
      phone.value = '';
      lastName.value = '';
      firstName.value = '';
      assetDescription.value = '';
      source.value = null;
      expectedAmount.value = '';
      validatorAmount.value = '';
      assetType.value = null;
      orderNote.value = '';
      workingAgent.value = null;
      validators.value = null;
      supportingValidator.value = null;
      city.value = null;
      district.value = null;
      address.value = null;

      if (props.editOrder) {
        stageOrder.value = null;
        stepOrder.value = null;
        staffUsername.value = '';
        branchName.value = '';
        appointment.value = null;
      }
    };

    const getIdAssetType = (inputAssetType) => assetTypes.value.find((element) => element.description === inputAssetType).id;

    const fetchOrder = () => (($router.currentRoute.path === PATHS.ORDERS) ? getOrderList() : getMyOrderList());
    const checkValid = (inputs) => {
      let valid = true;
      inputs.forEach((input) => {
        input.validateInput();
        valid = valid && input.isValid;
      });
      return valid;
    };

    const createOrderHandle = async (changeRouter) => {
      const inputs = [
        phoneInput.value, assetTypeInput.value, sourceInput.value
      ];

      if (isAtHomeSupport.value) {
        inputs.push(atHomeValidatorInput.value);
        inputs.push(atHomeAppointmentInput.value);
        inputs.push(cityInput.value);
        inputs.push(districtInput.value);
        inputs.push(addressInput.value);
      }

      if (checkValid(inputs) && assetDescriptionInput.value.validity.valid) {
        try{
          const orderAssetInfo = {
            asset: getIdAssetType(assetType.value),
            description: assetDescription.value
          };
          const orderAsset = await OrderManagementService.createAssetOrder(orderAssetInfo);

          if (orderAsset) {
            const now = moment();
            const newOrderInfo = {
              phone: phone.value,
              requiredAmount: expectedAmount.value === '' ? 0 : expectedAmount.value * 1000000,
              proposedAmount: validatorAmount.value === '' ? 0 : validatorAmount.value * 1000000,
              asset: orderAsset.id,
              dateClaim: now,
              status: ORDER_STATUS.IN_PROGRESS,
              step: ORDER_STEP.PENDING,
              stage: ORDER_STAGE.ORDER_CLAIMED.val,
              source: source.value,
              referralCode: (source.value === ORDER_SOURCE.REFERRAL) ? (referralCode.value || null) : null,
              isAtHomeSupport: isAtHomeSupport.value
            };
            if (firstName.value !== '') newOrderInfo.firstName = firstName.value;

            if (validators.value) newOrderInfo.validator = validators.value;

            if (isAtHomeSupport.value) {
              newOrderInfo.location = district.value || city.value;
              newOrderInfo.address = address.value;
              newOrderInfo.supportingValidator = supportingValidator.value;
            }

            const { item } = await OrderManagementService.createOrder(newOrderInfo);

            // add orderNote
            if (orderNote.value) {
              await OrderManagementService.addOrderNotes(item.id, orderNote.value);
            }

            if (changeRouter) {
              if (item) {
                $router.push(`${applyParams(PATHS.CONTRACT_EDITOR, '')}?orderId=${item.id}`);
              }
            } else {
              toggleEditOrder(false);
              fetchOrder();
              info('ORDER_CREATED');
              reset();
            }
          }
        }catch(err) {
          error(err);
        }
      }else {
        validateTextarea();
      }
    };

    const fetchNotes = async () => {
      if (!orderDetail.value.id) return;

      orderNotes.value = await OrderManagementService.getOrderNotes(orderDetail.value.id);
    };

    const addNotes = async (e) => {
      e.preventDefault();

      if (!orderDetail.value.id) return;

      if (!orderNote.value) return;

      await OrderManagementService.addOrderNotes(orderDetail.value.id, orderNote.value);
      await fetchNotes();
      orderNote.value = '';
    };

    const updateOrder = async () => {
      const assetInfo = {};
      if (assetType.value !== orderDetail.value.assetType) {
        assetInfo.asset = getIdAssetType(assetType.value);
      }
      if (assetDescription.value !== orderDetail.value.assetDescription) {
        assetInfo.asset = getIdAssetType(assetType.value);
        assetInfo.description = assetDescription.value;
      }

      const promiseList = [];

      if (Object.keys(assetInfo).length > 0) {
        const promise = OrderManagementService.updateAssetOrder(orderDetail.value.asset, assetInfo);
        promiseList.push(promise);
      }
      const orderNewInfo = {};
      if (phone.value !== orderDetail.value.phone) orderNewInfo.phone = phone.value;

      if (firstName.value !== orderDetail.value.firstName) orderNewInfo.firstName = firstName.value;

      if (expectedAmount.value !== ''
          && expectedAmount.value !== orderDetail.value.expectedAmount) orderNewInfo.requiredAmount = expectedAmount.value * 1000000;
      if (validatorAmount.value !== ''
          && validatorAmount.value !== orderDetail.value.validatorAmount) orderNewInfo.proposedAmount = validatorAmount.value * 1000000;

      if (stageOrder.value !== orderDetail.value.stage
          && stageOrder.value !== ORDER_STAGE.ACTIVE_CONTRACT.val) {
        orderNewInfo.stage = stageOrder.value;
        orderNewInfo.status = Object.values(ORDER_STAGE).find((ob) => ob.val === stageOrder.value).status;
      }
      if (stepOrder.value !== orderDetail.value.step
          && stepOrder.value !== ORDER_STEP.CONTRACT) orderNewInfo.step = stepOrder.value;

      if (source.value !== orderDetail.value.source) orderNewInfo.source = source.value;

      if (source.value === ORDER_SOURCE.REFERRAL) orderNewInfo.referralCode = referralCode.value || null;

      if (validators.value !== orderDetail.value.validator) orderNewInfo.validator = validators.value;

      if (appointment.value !== null) orderNewInfo.appointment = appointment.value;

      orderNewInfo.isAtHomeSupport = isAtHomeSupport.value;

      if (isAtHomeSupport.value) {
        orderNewInfo.location = district.value || city.value;
        orderNewInfo.address = address.value;
        orderNewInfo.supportingValidator = supportingValidator.value || undefined;
      }

      if (Object.keys(orderNewInfo).length > 0) {
        const promise = OrderManagementService.updateStage(orderDetail.value.id, orderNewInfo);
        promiseList.push(promise);
      }

      if (orderNote.value) {
        const promise = OrderManagementService.addOrderNotes(orderDetail.value.id, orderNote.value);
        promiseList.push(promise);
      }

      await Promise.all(promiseList);
    };

    const updateOrderFunc = async (outcome) => {
      const inputs = [
        phoneInput.value,
        assetTypeInput.value,
        sourceInput.value,
        stageOrderInput.value,
        stepOrderInput.value,
      ];

      if (!appointmentDisabled.value) {
        inputs.push(appointmentInput.value);
      }

      if (isAtHomeSupport.value) {
        inputs.push(atHomeValidatorInput.value);
        inputs.push(atHomeAppointmentInput.value);
        inputs.push(cityInput.value);
        inputs.push(districtInput.value);
        inputs.push(addressInput.value);
      }

      if (checkValid(inputs) && assetDescriptionInput.value.validity.valid) {
        await updateOrder();
        if (outcome) {
          outcome();
        }
      }
    };

    const updateOrderHandle = async () => {
      updateOrderFunc(() => {
        toggleEditOrder(false);
        fetchOrder();
        info('ORDER_UPDATE_SUCCESS');
      });
    };

    const search = (e) => {
      if (e.keyCode !== 13) {
        if(searchTime.value !== null) {
          clearTimeout(searchTime.value);
          searchTime.value = null;
        }
        searchTime.value = setTimeout(() => {
          let valid = true;
          valid = valid && phoneInput.value.isValid;
          if (valid) {
            getClientByPhoneNumber(phone.value);
          }
        }, 2000);
      }
    };

    const searchHandle = () => {
      if(searchTime.value !== null) {
        clearTimeout(searchTime.value);
        searchTime.value = null;
      }
      let valid = true;
      valid = valid && phoneInput.value.isValid;
      if (valid) {
        getClientByPhoneNumber(phone.value);
      }
    };

    const off = () => {
      modal.value.hide();
      if (!props.editOrder) resetClientState();
      reset();
    };

    const temptSaveData = () => {
      modal.value.hide();
    };

    const onShow = () => {
      clearValidateTextarea();
      if (props.editOrder) {
        OrderManagementService.setWorkingAgent(orderDetail.value.id);
      }
    };

    const onHide = () => {
      toggleEditOrder(false);
      if (orderDetail.value) {
        OrderManagementService.removeWorkingAgent(orderDetail.value.id);
      }
    };

    const contractHandle = () => {
      updateOrderFunc(() => {
        $router.push(`${applyParams(PATHS.CONTRACT_EDITOR, '')}?orderId=${orderDetail.value.id}`);
      });
    };

    const startCall = (number) => {
      setRef({ type: CALL_REFS.ORDER, refId: orderDetail.value.id });
      startOutboundCall(number);
    };

    const toggleIsAtHomeSupport = () => {
      isAtHomeSupport.value = !isAtHomeSupport.value;
    };

    watch(isOpen, async (newVal) => {
      if (newVal) {
        const inputs = [
          phoneInput.value,
          assetTypeInput.value,
          sourceInput.value,
          expectedAmountInput.value,
          validatorAmountInput.value,
        ];

        if (appointmentInput.value) {
          inputs.push(appointmentInput.value);
        }

        if (isAtHomeSupport.value) {
          inputs.push(atHomeValidatorInput.value);
          inputs.push(atHomeAppointmentInput.value);
          inputs.push(cityInput.value);
          inputs.push(districtInput.value);
          inputs.push(addressInput.value);
        }

        inputs.forEach((input) => {
          input.clearValidateMessage();
        });

        disabled.value = true;

        if (props.editOrder) {
          phone.value = orderDetail.value.phone;
          source.value = orderDetail.value.source;
          referralCode.value = orderDetail.value.referralCode;
          isAtHomeSupport.value = orderDetail.value.isAtHomeSupport;
          address.value = orderDetail.value.address;

          if (orderDetail.value.location) {
            const location = locations.value.find((item) => item.id === orderDetail.value.location);
            if (location.type.level === 2) {
              district.value = location.id;
              city.value = location.parent;
            } else {
              district.value = null;
              city.value = location.id;
            }
          }

          assetType.value = orderDetail.value.assetType;
          assetDescription.value = orderDetail.value.assetDescription;
          if (orderDetail.value.requiredAmount) expectedAmount.value = orderDetail.value.requiredAmount / 1000000;
          if (orderDetail.value.proposedAmount) validatorAmount.value = orderDetail.value.proposedAmount / 1000000;
          stageOrder.value = (orderDetail.value.stage);
          stepOrder.value = (orderDetail.value.step);
          staffUsername.value = orderDetail.value.staffUsername;
          supportUsername.value = orderDetail.value.supportUsername;
          branchName.value = orderDetail.value.branchName;
          firstName.value = orderDetail.value.firstName;
          lastName.value = orderDetail.value.lastName;
          if (orderDetail.value.appointment !== null) appointment.value = moment(orderDetail.value.appointment).format('YYYY-MM-DDTHH:mm');
          if (orderDetail.value.client) {
            firstName.value = orderDetail.value.clientFirstName;
          } else {
            clientDisabled.value = true;
          }
          if (orderDetail.value.validator !== null) validators.value = orderDetail.value.validator;
          if (orderDetail.value.supportingValidator) supportingValidator.value = orderDetail.value.supportingValidator;
          orderNotes.value = fetchNotes(orderDetail.value.id);
          disabled.value = !canWorkOn.value || false;
        }
        modal.value.show();
      } else {
        modal.value.hide();
        reset();
      }
    });


    watch(client, () => {
      if (client.value) {
        lastName.value = client.value.lastName;
        firstName.value = client.value.firstName;
        source.value = ORDER_SOURCE.OLD_CUSTOMER;
        newClient.value = false;
        disabled.value = false;
        clientDisabled.value = false;
      } else if(client.value === undefined) {
        lastName.value = '';
        firstName.value = '';
        source.value = null;
        newClient.value = true;
        disabled.value = false;
        clientDisabled.value = true;
      } else if(client.value === null) {
        disabled.value = true;
        clientDisabled.value = true;
      }
    });

    // check validate textarea
    watch(assetDescription, () => {
      validateTextarea();
      setTimeout(() => {
        resizeTextArea();
      }, 0);
    });

    watch(stepOrder, (newVal) => {
      if (newVal === orderDetail.value.step) {
        stageOrder.value = orderDetail.value.stage;
      } else if (newVal !== orderDetail.value.step) {
        stageOrder.value = '';
      }
    });

    watch(stageOrder, (newVal) => {
      if (newVal) {
        const condition = [
          newVal === ORDER_STAGE.CALL_AGAIN_LATER.val,
          newVal === ORDER_STAGE.APPOINTMENT_1.val,
          newVal === ORDER_STAGE.APPOINTMENT_2.val,
          newVal === ORDER_STAGE.APPOINTMENT_3.val,
          newVal === ORDER_STAGE.APPOINTMENT_4.val
        ];
        if (condition.includes(true)) {
          appointmentDisabled.value = false;
        } else {
          appointmentDisabled.value = true;
        }
      }
      if (newVal === ORDER_STAGE.ACTIVE_CONTRACT.val) {
        contractBtnDisabled.value = false;
      } else {
        contractBtnDisabled.value = true;
      }
    });

    watch(orderNotes, () => {
      if (!notesBox.value) return;

      notesBox.value.scrollTop = notesBox.value.scrollHeight;
    });

    return {
      ORDER_STEP,
      modal,
      assetType,
      assetTypeInput,
      phone,
      phoneInput,
      lastName,
      lastNameInput,
      firstName,
      firstNameInput,
      assetDescription,
      assetDescriptionInput,
      source,
      sourceInput,
      expectedAmount,
      expectedAmountInput,
      validatorAmount,
      validatorAmountInput,
      orderNote,
      orderNoteInput,
      stageOrder,
      stageOrderInput,
      stepOrder,
      stepOrderInput,
      staffUsername,
      staffUsernameInput,
      supportUsername,
      supportUsernameInput,
      branchName,
      branchNameInput,
      search,
      searchHandle,
      isOpen,
      off,
      onHide,
      onShow,
      assetOptions,
      ORDER_SOURCE,
      sourceOptions,
      disabled,
      temptSaveData,
      validateMessageTexarea,
      expectedAmountHint,
      validatorAmountHint,
      stepOptions,
      stageOptions,
      updateOrderHandle,
      faPaperPlane,
      faPhone,
      orderNotes,
      moment,
      appointment,
      appointmentInput,
      appointmentDisabled,
      addNotes,
      notesBox,
      contractBtnDisabled,
      contractHandle,
      clientDisabled,
      startCall,
      createOrderHandle,
      canWorkOn,
      validatorsOptions,
      validatorsInput,
      validators,
      isDesktop,
      faTimes,
      referralCode,
      isAtHomeSupport,
      toggleIsAtHomeSupport,
      atHomeValidatorInput,
      city,
      district,
      address,
      cityInput,
      districtInput,
      addressInput,
      cities,
      districts,
      atHomeAppointmentInput,
      atHomeSupportingValidatorInput,
      supportingValidator
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";
#new-order-modal {

  .at-home-support {
    padding-top: 20px;

    .input {
      width: 100%;
      margin-bottom: 10px;
    }

    .checkbox-wrapper {
      display: inline-block;

      .label {
        margin-left: 5px;
        vertical-align: top;
      }

      input {
        vertical-align: top;
        margin-top: 6px;
        cursor: pointer;
      }
    }
  }

  .modal-dialog {
    max-width: 750px;
  }
  .header {
    margin-top: 10px;
    margin-bottom: 20px;
    margin-left: 10px;
    font-size: 20px;
    font-weight: bold;
  }

  .container {
    margin-top: 35px;
    .row{
      margin-bottom: 30px;
    }
    .row:last-child {
      margin-bottom: 20px;
    }
  }

  .text-input {

    &.borderbottom {
      input {
        font-size: 16px;
      }
      #phone {
        small {
          margin-top: 2px;;
        }
      }
    }
  }
  .primary-button {
    margin-right: 10px;
  }
  .floating-label {
    width: 100%;
    position: relative;
    bottom: 10px;
    .select-input {
      width: 100%;
      small {
        position: absolute;
      }
      .display {
        border-bottom: 1px solid $alto;
        padding-left: 0px;
      }
      &:focus {
        outline: none;
        &~label {
          top:-12px;
          font-size:0.825em;
          color:$blueNcs;
        }
      }

      &:focus{
        &~.highlight{
          width: 100%;
        }
      }

      &.disabled {
        pointer-events: none;
        .display {
          border-bottom: 1px solid $silver;
        }
      }
    }
    label {
      color: $grey;
      font-size:14px;
      font-weight: bold;
      position:absolute;
      pointer-events:none;
      left:0px;
      top:13px;
      transition:0.2s ease all;
      -moz-transition:0.4s ease all;
      -webkit-transition:0.4s ease all;
      span {
        color: $geranium;
      }
    }

    .highlight{
      content:'';
      display: block;
      position: absolute;
      left:0;
      width: 0;
      height: 2px;
      background: $blueNcs;
      transition: all 200ms ease-out;
    }

    .floating-textarea {
      font-size:14px;
      padding: 4px 4px 4px 0px;
      display:block;
      width:100%;
      height:30px;
      border:none;
      border-bottom:1px solid $alto;
      overflow: hidden;
      resize: none;
      min-height: 30px;
      max-height: 400px;
      &:focus, &:not(:placeholder-shown) {
        outline: none;
        &~label {
          top:-12px;
          font-size:0.825em;
          color:$blueNcs;
        }
      }
      &:focus{
        &~.highlight{
          width: 100%;
        }
      }
    }

    &.disabled {
      label {
        color: $silver;
      }
      &:focus, &:not(:placeholder-shown):valid {
        &~label {
          top:-12px;
          font-size: 0.825em;
          color:$blueNcs;
        }
      }

      .floating-textarea {
        border-bottom: 1px solid $silver;
        background-color: unset;
      }
    }

    &.active {
      .select-input{
        &:focus, &:not(.value) {
        outline: none;
          &~label {
            top:-12px;
            font-size:0.825em;
            color:$blueNcs;
          }
        }
      }
    };
  }

  .textarea {
    bottom: 0px;
    label {
      top: 5px;
    }

    small {
      color: $geranium;
    }
  }

  .col-2 {

    small {

      span{
        color: $geranium;
        font-size: 18px;
      }
    }
  }

  .notes-wrapper {
    font-size: 13px;
    position: relative;
    height: 150px;
    border: 1px solid $alto;
    overflow-y: scroll;
    padding: 5px 10px;

    .notes {
      margin-top: 2px;
      font-size: 13px;
      height: 100%;
      p {
        margin: 0;
        span {
          color: $lavenderGrey;

          &:last-child {
            color: $independence;
          }
        }
      }
    }
  }

  .notes-input {
    margin-top: 17px;
    .text-input {
      .icon {
        transition: all .2s ease-in-out;
        cursor: pointer;

        &:hover {
          color: $paradisePink
        }
      }
    }
  }
  .phone-icon {
    .icon {
      transition: all .2s ease-in-out;
      cursor: pointer;
      color: $tuftsBlue;
      &:hover {
        transition: all .2s ease-in-out;
        color: $paradisePink
      }
    }
  }

  .btn-footer {
    display: flex;
    justify-content: flex-end;
  }

  .select-input {
    .select-box-wrapper {
      ul {
        li {
          display: block;
        }
      }
    }
  }

  @media (max-width: 991px) {
    .right {
      display: flex;
      justify-content: flex-end;

      .icon {
        cursor: pointer;
        color: $geranium;
        font-size: 20px;
        width: 30px;
        transition: all .2s ease-in-out;
        animation: mymove 5s infinite;

        &:hover {
          transform: scale(1.2);
        }
      }
    }
    .container {

      .row {
        margin-bottom: 0;

        .col-md-12 {
          margin-bottom: 25px;
        }

        .btn-footer {
          display: block;

           .primary-button {
            display: block;
            width: 100%;
            margin-bottom: 10px;
            border-radius: 3px;
          }
        }
      }
    }
  }
};
</style>
